import { isPendoEnabled } from '@/lib/env';
import { User } from '@/modules/types/user';

declare const window: any;

export const init = (companySubDomain: string, currentUser: User): void => {
  if (!isPendoEnabled() || !companySubDomain || !currentUser?.tmsUserUUID) {
    return;
  }

  const { pendo } = window;

  if (typeof pendo?.initialize !== 'function') {
    // Snippet blocked/slow or agent not loaded yet (ad blocker, CSP, timeout).
    // Common and harmless, so keep it low-key rather than a warning.
    // eslint-disable-next-line no-console
    console.debug('Pendo agent unavailable; skipping analytics for this session');
    return;
  }

  try {
    pendo.initialize({
      visitor: {
        id: currentUser.tmsUserUUID,
        email: currentUser.assessor,
        fullName: `${currentUser.givenName} ${currentUser.familyName}`,
        role: currentUser.roles?.[0],
      },
      account: {
        id: companySubDomain,
      },
    });
  } catch (error) {
    // Pendo is analytics-only; never let an agent-side throw escape into the
    // React effect and crash Course Builder (the MAYDAY-519 failure class).
    // eslint-disable-next-line no-console
    console.warn('Pendo initialization failed; continuing without analytics', error);
  }
};
